export default "__VITE_ASSET__BgPhh7jO__"